import notification from 'handlers/notification/notificationActionCreator';
import { NotificationComponentTypes } from 'handlers/notification/notificationTypes';
import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import getOriginalDisplayIdFromDuplicated from 'utils/getOriginalDisplayIdFromDuplicated';
import { openDuplicateApplicationPopup } from './ActionCreator';
import { DuplicateApplicationParams } from 'LoanOriginationSystemApplications/Types';

const openDuplicateApplicationPopupOrShowErrorMessage = (params: DuplicateApplicationParams, dispatch: Dispatch<AnyAction>) => {
  if (params.originalApplicationId) {
    notification.createNotification(
      {
        componentType: NotificationComponentTypes.DuplicateApplicationError,
        props: {
          originalApplicationDisplayId: getOriginalDisplayIdFromDuplicated(params.displayId),
        },
      },
      'error',
      dispatch,
    );

    return;
  }

  dispatch(openDuplicateApplicationPopup(params));
};

export default openDuplicateApplicationPopupOrShowErrorMessage;
